import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";

export default function NotFound() {
  const loc = useLocation();
  const nav = useNavigate();
  useEffect(() => { window.scrollTo(0, 0); }, [loc.pathname]);
  return (
    <div className="section-y" data-testid="not-found-page">
      <div className="container-x text-center">
        <p className="eyebrow">404</p>
        <h1 className="font-serif text-6xl md:text-8xl text-primary mt-4">Page not found.</h1>
        <p className="mt-6 text-muted-foreground">The page you&apos;re looking for doesn&apos;t exist.</p>
        <Button onClick={() => nav("/")} className="mt-8 rounded-none uppercase tracking-[0.18em] text-xs px-6 py-3.5 h-auto">Back to Home</Button>
      </div>
    </div>
  );
}
